import React, { createContext, useContext, useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';
import { useDispatch } from 'react-redux';
import { authActions, masterActions, staffRequestAction } from '../_store';
import { getStoredValue, setStoredValue } from '../_helpers/storagehelper';

const SignalRContext = createContext(null);

export const SignalRProvider = ({ children }) => {
  const [connection, setConnection] = useState(null);
  const dispatch = useDispatch();
  const storeduser = getStoredValue("user");
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  useEffect(() => {
    function capitalizeKeys(obj) {
      const newObj = {};
      for (const key in obj) {
        if (Object.hasOwn(obj, key)) {
          const capitalKey = key.charAt(0).toUpperCase() + key.slice(1);
          newObj[capitalKey] = obj[key];
        }
      }
      return newObj;
    }

    function handlesidemenuData() {
      dispatch(masterActions.GetLoadNotificationAlert({
        ManagementUserID: storeduser.ManagementUserID,
        FacilityID: getStoredValue("commonFacilityCode"),
        isNoLoading: true
      })
      ).then((response) => {
        const updatedMenuList =
          getStoredValue("menu_list") ||
          response?.payload;
        if (updatedMenuList) {
          dispatch(authActions.updateMenuList(updatedMenuList));
        }
      });
    }

    function handleStaffReqsidemenuData() {
      if (storeduser?.UserRoleID === 10 || storeduser?.UserRoleID === 11) {
        dispatch(
          masterActions.GetPublicDefenderNotificationAlert({
            ManagementUserID: storeduser.ManagementUserID,
            FacilityID: getStoredValue("commonFacilityCode"),
            isNoLoading: true
          })
        ).then((response) => {
          const updatedMenuList =
            getStoredValue("menu_list") || response?.payload;

          if (updatedMenuList) {
            dispatch(authActions.updateMenuList(updatedMenuList));
          }
        });

        dispatch(
          staffRequestAction?.getInmateMessageCount({
            FacilityCode: getStoredValue("commonFacilityCode"),
            ManagementUserID: storeduser.ManagementUserID,
            isNoLoading: true
          })
        );
      } else {
        dispatch(
          masterActions.GetLoadNotificationAlert({
            ManagementUserID: storeduser.ManagementUserID,
            FacilityID: getStoredValue("commonFacilityCode"),
            isNoLoading: true
          })
        ).then((response) => {
          const updatedMenuList =
            getStoredValue("menu_list") || response?.payload;

          if (updatedMenuList) {
            dispatch(authActions.updateMenuList(updatedMenuList));
          }
        });

        dispatch(
          staffRequestAction?.getInmateMessageCount({
            FacilityCode: getStoredValue("commonFacilityCode"),
            ManagementUserID: storeduser.ManagementUserID,
            isNoLoading: true
          })
        );

        dispatch(
          staffRequestAction?.LoadPrivateConversationRequestUnreadCount({
            ManagementUserID: storeduser.ManagementUserID,
            FacilityID: getStoredValue("commonFacilityCode"),
            isNoLoading: true
          })
        );
      }
    }

    const startConnection = async () => {
      const newConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${baseUrl}/chatHub`, { withCredentials: true })
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Information)
        .build();

      /** ----------------------------------------------------
       *  REGISTER ALL LISTENERS BEFORE start()
       *  ---------------------------------------------------- */
      newConnection.on("ReceiveMessage", (user, message, type) => {
        const capitalizedData =
          type === "ManagementUser_Menu_Update"
            ? message
            : capitalizeKeys(message);

        dispatch(authActions.updateSignalRData({ user, message: capitalizedData, type }));

        switch (type) {
          case "Public_Inmate_Connection_Request":
          case "Send_Photo":
          case "Send_PostalMail":
            if (getStoredValue("commonFacilityCode") == message?.facilityID)
              handlesidemenuData();
            break;

          // case "Request_AdminRemedy_CUD":
          //   if (
          //     getStoredValue("commonFacilityCode") == message?.facilityID ||
          //     getStoredValue("commonFacilityCode") == message?.pdsFacilityID
          //   )
          //     handleStaffReqsidemenuData();
          //   break;

          case "ManagementUser_Menu_Update":
            if (storeduser.ManagementUserID == user.toString()) {
              dispatch(
                authActions.GetAllManagementUserAccessPermission({
                  ManagementUserID: storeduser.ManagementUserID,
                  ManagementMenuID: 0
                })
              );
              const updatedMenuList = JSON.parse(message);
              if (updatedMenuList) {
                dispatch(authActions.updateMenuList(updatedMenuList));
              }
            }
            break;
        }
      });

      /** -------------------
       *  RECONNECT HANDLERS
       * ------------------- */
      newConnection.onreconnecting(() => {
        console.log("SignalR reconnecting...");
      });

      newConnection.onreconnected(async () => {
        console.log("SignalR successfully reconnected.");

        // 🔥 DO NOT CALL start() AGAIN
        // 🔥 ONLY Re-register user
        if (storeduser?.ManagementUserID) {
          const newId = await newConnection.invoke(
            "RegisterUser",
            `Admin_${storeduser.ManagementUserID}`
          );

          const oldId = getStoredValue(`signalRId_${storeduser.ManagementUserID}`);

          if (oldId && oldId !== newId) {
            newConnection.invoke("RemoveUser", oldId.toString());
          }

          setStoredValue(`signalRId_${storeduser.ManagementUserID}`, newId);
        }
      });

      newConnection.onclose((error) => {
        console.log("SignalR closed:", error);
        // ❌ Do NOT manually call start() — automaticReconnect will handle this
      });

      /** -------------------
       * START CONNECTION ONCE
       * ------------------- */
      try {
        await newConnection.start();

        if (storeduser?.ManagementUserID) {
          const newId = await newConnection.invoke(
            "RegisterUser",
            `Admin_${storeduser.ManagementUserID}`
          );
          setStoredValue(`signalRId_${storeduser.ManagementUserID}`, newId);
        }

        dispatch(authActions.updateconnectionData(newConnection));
        setConnection(newConnection);
      } catch (err) {
        console.log("SignalR start error:", err);
      }
    };

    startConnection();

    return () => {
      if (connection) connection.stop();
    };
  }, []); // Only run on mount

  return (
    <SignalRContext.Provider value={connection}>
      {children}
    </SignalRContext.Provider>
  );
};

export const useSignalR = () => useContext(SignalRContext);
